export default __webpack_public_path__ + "static/media/file-icon.d1939ac7.svg";